import React from 'react';
import {connect} from 'react-redux';
import __ from 'lodash';
import {cekCookies} from '../../../../actions';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import LoaderModal from '../../../modal/LoaderModal';
import ExamList from './ExamList';
import ExamForm from './ExamForm';
import MapelForm from './MapelForm';
import { Alert } from 'react-bootstrap';

class Exam extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            profil: {},
            subProfil: {},
            setProfilId: '',
            kelas:[],
            mapel:[],
            tematik:[],
            error: null,
            resMessage: {}  ,
            isFetching: false ,            
            isAddExam: false,
            isEditExam: false,
            isAddMapel: false,
            isEditMapel: false,
            alertShow: false,
        }
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.addMapel = this.addMapel.bind(this);
        this.onSubmitSubProfil = this.onSubmitSubProfil.bind(this);
    }    

    async componentDidMount() { 
        document.title = "Exam";
        this.fetchKelas();   
    }    

    fetchKelas = async () => {
        const response = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_KELAS)
        .catch(function(error){});
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelas: response.data.data
                })
            }
        }
    }

    fetchMapel = async ( idKelas) => {
        this.setState({ isFetching: true, mapel:[] });
        const response = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_FETCH_MAPEL_BY_ID_KELAS + idKelas)
        .catch(function(error){});
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    mapel: response.data.data
                })
            }
        }
        this.setState({ isFetching: false });
    }

    fetchTematik = async ( idKelas) => {
        this.setState({ isFetching: true, tematik:[] });
        const response = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_FETCH_TEMATIK_BY_ID_KELAS, {
            params: { idKelas: idKelas }
        }).catch(function(error){ console.log(error)});
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    tematik: response.data.data
                })
            }
        }
        this.setState({ isFetching: false });
    }

    onCreate() {
        this.setState({ isAddExam: true});
    }
    onEdit = async(id) => {  
        this.setState({ isFetching: true });
        const result = await accountManagement.get(CONFIG.EXAM_GET_BY_ID +'?id='+ id)
            .catch(function(error){
                this.setState({error});
            });
        
        if (result) {            
            this.setState({ 
                profil: result.data.data,
                isAddExam: false,
                isEditExam: true
            });
            
        } 
        this.setState({ isFetching: false });        
    } 
    onFormSubmit = async (data) => {
        this.setState({ isFetching: true });
        let apiUrl;
    
        if(this.state.isAddExam){
           apiUrl = CONFIG.EXAM_TAMBAH;
        } else {
           apiUrl = CONFIG.EXAM_UPDATE;
        }
   
        // const dataSend = {
        //     ...data, 
        //     'idAdmin' : this.props.account.idAdmin,
        //     'idSekolah' : this.props.account.idSekolah
        // } 
        const tambah = await accountManagement.post(apiUrl, data)
            .catch(function(error){
                this.setState({error});
            });
        
        if (tambah) {            
            this.setState({ 
                profil: {},
                resMessage: tambah.data.errorSchema,
                isAddExam: false,
                isEditExam: false
            });
        }  
        this.setState({ isFetching: false, alertShow: true });    
    }


    addMapel(idProfil, idKelas) {
        this.fetchMapel(idKelas);
        this.fetchTematik(idKelas);
        this.setState({ isAddMapel: true, setProfilId: idProfil})
    }

    editMapel = async(idProfil, idSubrofil, idKelas) => {
        this.setState({ isFetching: true });
        this.fetchMapel(idKelas);
        this.fetchTematik(idKelas);
        const result = await accountManagement.get(CONFIG.EXAM_GET_SUBPROFIL_BY_ID + idSubrofil)
            .catch(function(error){
                this.setState({error});
            });
        
        if (result) {            
            this.setState({ 
                subProfil: result.data.data,
                setProfilId: idProfil,
                isAddMapel: false,
                isEditMapel: true
            });
            
        } 
        this.setState({ isFetching: false });  
    }

    onSubmitSubProfil = async(data) => {        
        this.setState({ isFetching: true});
        let apiSubUrl;
    
        if(this.state.isAddMapel){
            apiSubUrl = CONFIG.EXAM_ADD_MAPEL;
        } else {
            apiSubUrl = CONFIG.EXAM_EDIT_MAPEL;
        }
        const addSubProfil = await accountManagement.post(apiSubUrl, data)
            .catch(function(error){
                this.setState({error});
            });
        
        if (addSubProfil) {            
            this.setState({ 
                subProfil: {},
                resMessage: addSubProfil.data.errorSchema,
                isAddMapel: false,
                isEditMapel: false
            });
        }  
        this.setState({ isFetching: false, alertShow: true });   
    }

    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage.errorMessage}</strong>
            </Alert>
          );
        } 
    }

    handleBack = () => {        
        this.setState({ 
            profil: {},
            subProfil: {},
            isAddExam: false ,
            isEditExam: false,
            isAddMapel: false,
            isEditMapel: false           
        }); 
        //document.getElementById('col-parent-'+ value).classList.add('show');
    }
    

    render() {         
        let addEditExam;        
        if(this.state.isAddExam || this.state.isEditExam) {
            addEditExam = <ExamForm onFormSubmit={this.onFormSubmit} handleBack={this.handleBack}
                profil={this.state.profil} kelas={this.state.kelas}/>
        }

        let addEditMapel;
        if(this.state.isAddMapel || this.state.isEditMapel) {
            addEditMapel = <MapelForm onSubmitSubProfil={this.onSubmitSubProfil} idProfilCbt={this.state.setProfilId}
                handleBack={this.handleBack} mapel={this.state.mapel} tematik={this.state.tematik} subProfil={this.state.subProfil} />
        }

        return (
        <div className="wrapper">
            <LoaderModal isFetching={this.state.isFetching} />
            <Sidebar account={this.props.account}/>
            <div id="content" style={{paddingBottom: '50px'}}>
                <Navbar /> 
                <div className="container-fluid">                  
                    {this.loadAlert()}    
                    {!addEditExam && !addEditMapel && <div className="row">                       
                        <div className="col-sm-6 col-xs-6"><h2>List Exam</h2></div>
                        <div className="col-sm-6 col-xs-6 ">
                            {!this.state.isAddExam &&
                            <button onClick={() => this.onCreate()} className="btn btn-outline-primary pull-right">tambah</button> 
                            }
                        </div>
                    </div> }
                    {!addEditExam && !addEditMapel && 
                    <ExamList 
                      show={this.state.show} 
                      onEdit={this.onEdit}
                      addMapel={this.addMapel}  
                      editMapel={this.editMapel}                    
                    />} 
                                
                </div> 
                {addEditExam}  
                {addEditMapel} 
            </div>

            
            
            
                    
        </div>
        
        )
    }

    

}

const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(Exam);